import { animate, AnimationBuilder, style } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/animations";
import * as i3 from "@angular/router";
var FuseSplashScreenService = /** @class */ (function () {
    function FuseSplashScreenService(document, animationBuilder, router) {
        this.document = document;
        this.animationBuilder = animationBuilder;
        this.router = router;
        this.splashScreenElement = this.document.body.querySelector('#fuse-splash-screen');
        this.bodyElement = this.document.querySelector('body');
        this.init();
    }
    FuseSplashScreenService.prototype.init = function () {
        var _this = this;
        this.router.events
            .pipe(filter((function (event) { return event instanceof NavigationEnd; })), take(1))
            .subscribe(function () { return setTimeout(function () {
            _this.hide();
        }, 0); });
    };
    FuseSplashScreenService.prototype.show = function () {
        this.bodyElement.prepend(this.splashScreenElement, this.bodyElement.firstChild);
        var shotAnimation = this.animationBuilder
            .build([
            style({ opacity: '0', zIndex: '99999' }),
            animate('300ms ease', style({ opacity: '1' }))
        ])
            .create(this.splashScreenElement);
        setTimeout(function () {
            shotAnimation.play();
        }, 0);
    };
    FuseSplashScreenService.prototype.hide = function () {
        this.splashScreenElement.remove();
    };
    FuseSplashScreenService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseSplashScreenService_Factory() { return new FuseSplashScreenService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.AnimationBuilder), i0.ɵɵinject(i3.Router)); }, token: FuseSplashScreenService, providedIn: "root" });
    return FuseSplashScreenService;
}());
export { FuseSplashScreenService };
